// route actions
const toPage = (page) => ({
  type: "route/toPage",
  page: page,
});

const actionAfterPage = (action) => ({
  type: "route/actionAfterPage",
  page: action,
});

const toolChange = (tool) => ({
  type: "route/toolChange",
  tool: tool,
});

const routerActions = {
  toPage,
  actionAfterPage,
  toolChange,
};

export default routerActions;
